import { Box } from '@mui/material';
import { useRef, useState } from 'react';
import WeeklyColumn from './WeeklyColumn';
import WeeklyHourLabel from './WeeklyHourLabel';

const WeeklyGrid = ({
  days,
  setDays,
  snapToGrid,
  snapRatio,
  hourStart,
  hourEnd,
  res,
  resHeight,
  edit,
  labelFormat = 'YYYY-MM-DD dddd',
  onDateClick,
  userId,
  onDoubleClick,
  onEventEdit,
  onEventSelect,
  calendars,
  onUpdate,
  selectedPeriod,
  onCreateEventInDayView,
  onClose,
}) => {
  const [enableTouchScroll, setEnableTouchScroll] = useState(true);
  const exoWorkdayRef = useRef(null);
  const labelWidth = 40;
  const lineWidth = 1;
  const dayLabelHeight = 55;

  function handleAdd() {}
  function handleDelete() {}

  function maxLayersInWeek(eventDays) {
    var maxLayers = 0;
    eventDays?.forEach((day) => {
      const { events } = day;
      var maxLayersInDay = 0;
      events.forEach((event) => {
        if (!event.wholeDay) return;
        if (event.layer + 1 > maxLayersInDay) maxLayersInDay = event.layer + 1;
      });

      if (maxLayers < maxLayersInDay) maxLayers = maxLayersInDay;
    });
    return maxLayers;
  }

  const offsetTop = maxLayersInWeek(days) * 24; // layers with 20px height + 4px y padding for spacing

  return (
    <Box
      className="flex flex-row w-full h-full overflow-y-auto"
      ref={exoWorkdayRef}
    >
      <Box
        className="flex flex-col h-full"
        sx={{
          paddingTop: `${dayLabelHeight + resHeight / 2 + offsetTop}px`,
          gap: `${resHeight * (res - 1)}px`,
        }}
      >
        {[...Array(hourEnd - hourStart)].map((e, i) => (
          <WeeklyHourLabel
            key={i}
            width={labelWidth}
            resHeight={resHeight}
            hour={i + hourStart}
          />
        ))}
      </Box>

      {days?.map((day, i) => (
        <WeeklyColumn
          userId={userId}
          onDateClick={onDateClick}
          dayLabelHeight={dayLabelHeight}
          edit={edit}
          setEnableTouchScroll={setEnableTouchScroll}
          exoWorkdayRef={exoWorkdayRef}
          days={days}
          day={day}
          index={i}
          key={day.id}
          onAdd={handleAdd}
          onDelete={handleDelete}
          snapToGrid={snapToGrid}
          snapRatio={snapRatio}
          hourStart={hourStart}
          hourEnd={hourEnd}
          res={res}
          resHeight={resHeight}
          labelFormat={labelFormat}
          onDoubleClick={onDoubleClick}
          onEventEdit={onEventEdit}
          onEventSelect={onEventSelect}
          calendars={calendars}
          onUpdate={onUpdate}
          offsetTop={offsetTop}
          selectedPeriod={selectedPeriod}
          onCreateEventInDayView={onCreateEventInDayView}
          onClose={onClose}
        />
      ))}
    </Box>
  );
};

export default WeeklyGrid;
